export default __webpack_public_path__ + "img/d9e82c72a6813430922d0a78b4383004.png";